/**
 * Consultants data — iter638
 *
 * Single source of truth for consultant profiles. Used by:
 *   /consultants                  → listing
 *   /consultants/inkov            → ConsultantInkovPage
 *   /consultants/ivanova          → ConsultantIvanovaPage
 */

export const DR_INKOV_PHOTO =
  "https://customer-assets.emergentagent.com/job_endocrine-hub-2/artifacts/rq0dfr56_ivan-inkov-snimka.jpg";
export const DR_LILI_PHOTO =
  "https://customer-assets.emergentagent.com/job_endocrine-hub-2/artifacts/491ezsoj_lili-ivanova-snimka.jpg";

// ── Bulgarian (default) ─────────────────────────────────────────────
const inkov_bg = {
  slug: "inkov",
  accent: "fuchsia",
  photo: DR_INKOV_PHOTO,
  name: "Д-р Иван Инков",
  short_role: "Гръден хирург и онкомамолог",
  role: "Гръден хирург и онкомамолог · Основател и научен директор",
  location: "София, България",
  orcid_label: "ORCID",
  orcid: "0000-0001-6084-1707",
  orcid_url: "https://orcid.org/0000-0001-6084-1707",
  booking_url: "https://superdoc.bg/lekar/ivan-inkov",
  summary:
    "Специалист гръден хирург и онкомамолог. Основател и научен директор на Nutramilo — обединява гръдната хирургия, торакалната онкология и мастологията в научния скелет на платформата.",
  bio: [
    "Специалист гръден хирург и онкомамолог в София. Оперира по линия на НЗОК/ДЗОФ в МБАЛ Сердикамед и МБАЛ ВИТА-База 2. Предлага и онлайн консултация през Healee.",
  ],
  edu_title: "Образование",
  edu: [
    "Специализация по Гръдна хирургия във Военномедицинска академия София — 5 години",
    "Специализация по Торакална онкология (CAS) — Цюрихски университет, Швейцария — 16 месеца",
    "Специализация по Онкомамология (CCB) — Университет в Улм, Германия — 15 месеца",
    "Завършил Колеж на Европейското училище по онкология (ESO)",
    "Посланик на Европейско училище по онкология (ESO) за България",
    "Специализирани курсове: Европейски институт по онкология в Милано, Кралският колеж в Лондон, програми в Белгия, Португалия, Швейцария и Германия",
  ],
  quals_title: "Квалификации и компетенции",
  quals: [
    "Сертификат за компетентност по рак на белия дроб — Цюрихски университет",
    "Сертификат за компетентност по рак на млечната жлеза — Университет Улм",
    "Диплома по мастология — доброкачествени заболявания и преканцерози — Университет на Монпелие",
    "Специализирани курсове по диагностика на млечна жлеза в Истанбул, Атина и Пафос",
    "Десетки публикации в областта на онкохирургията и заболяванията на млечната жлеза",
    "Автор на 4 книги: Заболявания на млечната жлеза (2 издания), Заболявания на гърдата при мъжа, Ръководство по белодробни болести",
  ],
  role_in_app_title: "Роля в Nutramilo",
  role_in_app:
    "Като основател и научен директор на Nutramilo, Д-р Инков обединява своите специализации — гръдна хирургия, торакална онкология, онкомамология и мастология — в научния скелет на платформата. Превежда международния си опит (Цюрих, Улм, Монпелие, Милано, Лондон, ESO) в адаптивни алгоритми, ръководи интеграцията на 20-те дигитални близнака с реалните клинични пътеки и пази всеки модул на Nutramilo да говори на езика на профилактиката и персонализираното решение — не на общите препоръки.",
};

const ivanova_bg = {
  slug: "ivanova",
  accent: "cyan",
  photo: DR_LILI_PHOTO,
  name: "Д-р Лили Иванова",
  short_role: "Стоматолог · DHI консултант",
  role: "Стоматолог · Консултант Дентално здраве",
  location: "София, България",
  booking_url: "https://superdoc.bg/lekar/lili-ivanova",
  summary:
    "Стоматолог в София и водещ архитект на Dental Health Intelligence (DHI) — следващия модул на Nutramilo, който свързва устната кухина с цялото тяло.",
  bio: [
    "Стоматолог в София с интереси във възстановителна дентална медицина, ортодонтия и детска дентална медицина (преглежда деца над 1 г.). Работи с вредни навици — смукане на пръст, устно дишане, стискане на зъби — и извършва ранна корекция на неправилно подредени зъби още в етапа на млечното съзъбие.",
  ],
  edu_title: "Образование",
  edu: [
    "Завършва Факултет по Дентална медицина към Медицински университет – Пловдив",
  ],
  quals_title: "Квалификации",
  quals: [
    "Научни постери: Дигитално планиране на естетично възстановяване във видимото съзъбие; Лечение на зъбна флуороза чрез инфилтрация",
    "Член на Български зъболекарски съюз",
    "Член на Контролния орган на Европейската асоциация на студентите по дентална медицина",
    "Ранно ортодонтско лечение и миофункционална терапия",
    "Минимално-инвазивни принципи в кариесологията. Кариесна инфилтрация",
    "Индивидуално обучение за орална хигиена — Академия Кураден",
    "Фронтални и дистални възстановявания",
    "Ортодонтски практически курсове по дисциплината Alexander",
  ],
  role_in_app_title: "Роля в Nutramilo",
  role_in_app:
    "Д-р Иванова е научен консултант и водещ архитект на Dental Health Intelligence (DHI) — следващия голям модул на Nutramilo. Превежда своите специализации във възстановителна дентална медицина, ортодонтия и детска дентална медицина в дигиталния близнак: ранно откриване на орални парафункции, миофункционални рискове и връзка устна кухина ↔ системно здраве (метаболизъм, диабет, бременност, сърце). Чрез нея Nutramilo става единствената здравна платформа в България с интегриран дентално-системен изглед — нов вход за пациенти, които идват първо за усмивка, а намират цялостен дигитален здравен близнак.",
};

// ── English ─────────────────────────────────────────────────────────
const inkov_en = {
  ...inkov_bg,
  name: "Dr. Ivan Inkov, MD",
  short_role: "Breast surgeon & oncoplastic specialist",
  role: "Breast surgeon & oncoplastic specialist · Founder & Scientific Director",
  location: "Sofia, Bulgaria",
  summary:
    "Breast surgeon, oncoplastic specialist and founder of Nutramilo. Combines thoracic surgery, oncology and mastology into the scientific backbone of the platform.",
  bio: [
    "Breast surgeon and oncomammologist based in Sofia. Operates under the Bulgarian NHIF at MHAT Serdikamed and MHAT VITA-Base 2; also offers remote consultations via Healee.",
  ],
  edu_title: "Education",
  edu: [
    "Specialisation in Thoracic Surgery — Military Medical Academy, Sofia (5 years)",
    "Certificate of Advanced Studies (CAS) in Thoracic Oncology — University of Zurich (16 months)",
    "Certificate of Competence in Breast Cancer (CCB) — University of Ulm (15 months)",
    "European School of Oncology College graduate",
    "Ambassador of the European School of Oncology (ESO) for Bulgaria",
    "Specialised courses at the European Institute of Oncology (Milan), King's College London, and programmes in Belgium, Portugal, Switzerland and Germany",
  ],
  quals_title: "Qualifications & competencies",
  quals: [
    "Certificate of Competence in Lung Cancer — University of Zurich",
    "Certificate of Competence in Breast Cancer — University of Ulm",
    "Mastology Diploma (benign breast disease & precancers) — University of Montpellier",
    "Specialised breast diagnostics courses — Istanbul, Athens, Paphos",
    "Dozens of publications in oncological surgery and breast disease",
    "Author of 4 books, incl. Diseases of the Breast (2 editions), Male Breast Disease, Handbook of Lung Diseases",
  ],
  role_in_app_title: "Role at Nutramilo",
  role_in_app:
    "As founder and Scientific Director of Nutramilo, Dr. Inkov unifies his specialisations — thoracic surgery, thoracic oncology, oncoplastic breast surgery and mastology — into the scientific backbone of the platform. He translates his international training (Zurich, Ulm, Montpellier, Milan, London, ESO) into adaptive algorithms, leads the integration of the 20 digital twins with real-world clinical pathways and ensures every module speaks the language of prevention and personalised decision-making — not generic advice.",
};

const ivanova_en = {
  ...ivanova_bg,
  name: "Dr. Lili Ivanova",
  short_role: "Dentist · DHI consultant",
  role: "Dentist · Dental Health consultant",
  location: "Sofia, Bulgaria",
  summary:
    "Dentist in Sofia and lead architect of Dental Health Intelligence (DHI) — the next Nutramilo module connecting the oral cavity with the whole body.",
  bio: [
    "Dentist in Sofia focused on restorative dentistry, orthodontics and paediatric dental medicine (sees children from age 1). Works with oral parafunctions — thumb sucking, mouth breathing, bruxism — and early correction of malposed teeth during the deciduous stage.",
  ],
  edu_title: "Education",
  edu: [
    "Faculty of Dental Medicine, Medical University – Plovdiv",
  ],
  quals_title: "Qualifications",
  quals: [
    "Scientific posters: Digital planning of aesthetic restorations in the visible dentition; Treatment of dental fluorosis via infiltration",
    "Member of the Bulgarian Dental Association",
    "Member of the Control body of the European Dental Students' Association",
    "Early orthodontic treatment & myofunctional therapy",
    "Minimally-invasive principles in cariology · caries infiltration",
    "Individual oral hygiene training — Curaden Academy",
    "Anterior & posterior restorations",
    "Orthodontic practical courses based on the Alexander discipline",
  ],
  role_in_app_title: "Role at Nutramilo",
  role_in_app:
    "Dr. Ivanova is the scientific consultant and lead architect of Dental Health Intelligence (DHI) — the next flagship Nutramilo module. She translates her expertise in restorative dentistry, orthodontics and paediatric dental medicine into the digital twin: early detection of oral parafunctions, myofunctional risks and the oral-to-systemic link (metabolism, diabetes, pregnancy, cardiovascular). Through her, Nutramilo becomes the only health platform in Bulgaria with an integrated dental-systemic view — a new entry point for patients who come first for a smile and discover a full digital health twin.",
};

export const CONSULTANTS = {
  bg: { inkov: inkov_bg, ivanova: ivanova_bg },
  en: { inkov: inkov_en, ivanova: ivanova_en },
  es: { inkov: inkov_en, ivanova: ivanova_en },
};

export function getConsultant(language, slug) {
  const lang = language === "en" ? "en" : "bg";
  return CONSULTANTS[lang][slug] || null;
}

export function listConsultants(language) {
  const lang = language === "en" ? "en" : "bg";
  return [CONSULTANTS[lang].inkov, CONSULTANTS[lang].ivanova];
}
